import HouseDesignForm from "../component/HouseDesignForm";

const HouseDesignCreate = () => {
  return <HouseDesignForm isEditMode={false} />;
};

export default HouseDesignCreate;
